'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Button = require('@narvar/nth-block-button');
var nthBitHeader = require('@narvar/nth-bit-header');
var language_en_US = require('../../../consts/language_en_US.js');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/index.js');
require('../../../components/Button/styles.js');
var index$1 = require('../../../components/Icon/index.js');
require('../../../components/LocationCard/index.js');
require('../../../components/PudoCard/index.js');
require('../../../components/ItemCard/index.js');
require('../../../components/SelectItem/index.js');
require('../../../components/SelectList/index.js');
require('../../../components/ErrorBanner/index.js');
require('../../../components/Footer/index.js');
require('../../../components/StickyFooter/index.js');
require('../../../components/SwatchesList/index.js');
require('@babel/runtime/helpers/extends');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/index.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/ItemCardSkeleton.js');
require('../../../components/Skeleton/LineItemSkeleton.js');
require('../../../components/Skeleton/PudoCardSkeleton.js');
var useLanguage = require('../../../hooks/useLanguage.js');
var index$2 = require('../../../components/FileUpload/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const tempLanguageKeys = {
  returnsReasonsPicturesTitle: language_en_US["default"].returnsReasonsPicturesTitle,
  returnsReasonsPicturesUploadButton: language_en_US["default"].returnsReasonsPicturesUploadButton,
  returnsReasonsPicturesUploadDescription: language_en_US["default"].returnsReasonsPicturesUploadDescription
};
const ReturnReasonsPictures = _ref => {
  let {
    pictures,
    maxSize,
    minCount,
    maxCount,
    hideSubmit,
    onChange,
    onSubmit
  } = _ref;
  const {
    returnsReasonsPicturesTitle,
    returnsReasonsPicturesUploadButton,
    returnsReasonsPicturesUploadDescription
  } = tempLanguageKeys;
  const {
    returnsActionsNext
  } = nthHookTranslations.useTranslations();
  const uploadButtonLabel = useLanguage["default"]({
    langKey: 'returnsReasonsPicturesUploadButton',
    defaultString: returnsReasonsPicturesUploadButton
  }).value;
  const uploadCaption = useLanguage["default"]({
    langKey: 'returnsReasonsPicturesUploadDescription',
    defaultString: returnsReasonsPicturesUploadDescription
  }).value;
  const isValid = (!maxCount || maxCount >= ((pictures === null || pictures === void 0 ? void 0 : pictures.length) ?? 0)) && (!minCount || minCount <= ((pictures === null || pictures === void 0 ? void 0 : pictures.length) ?? 0));
  const handleChange = acceptedFiles => {
    onChange === null || onChange === void 0 ? void 0 : onChange(acceptedFiles);
  };
  const handleSubmit = () => {
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsPicturesTitle",
    defaultString: returnsReasonsPicturesTitle
  })), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    icon: "PlaceholderPictures"
  }), /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    accept: ".jpg, .jpeg, .png",
    multiple: maxCount !== 1,
    maxSize: maxSize,
    maxCount: maxCount,
    outline: true,
    big: true,
    label: uploadButtonLabel,
    caption: uploadCaption,
    value: pictures,
    onChange: handleChange
  }), !hideSubmit && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: !isValid,
    onClick: handleSubmit
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsActionsNext",
    defaultString: returnsActionsNext
  })));
};

exports["default"] = ReturnReasonsPictures;
